import { render, staticRenderFns } from "./Exchangedea.vue?vue&type=template&id=192351f4&scoped=true"
import script from "./Exchangedea.vue?vue&type=script&lang=js"
export * from "./Exchangedea.vue?vue&type=script&lang=js"
import style0 from "./Exchangedea.vue?vue&type=style&index=0&id=192351f4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192351f4",
  null
  
)

export default component.exports